import initPlayer from "./initPlayer";

const playYoutubeVideo = (video) => {
  const cover = video.querySelector('[data-youtube-video-overlay]');
  const spinner = video.querySelector('[data-youtube-video-spinner]');
  const trigger = video.querySelector('[data-youtube-video-trigger]');
  const playerId = video.querySelector('[data-youtube-player-id]').id;
  const videoId = video.dataset.youtubeVideoId;

  const player = initPlayer(playerId, videoId);

  trigger.addEventListener('click', (e) => {
    cover.style.display = 'none';
    spinner.style.display = 'none';
    trigger.style.display = 'none';

    player.playVideo();
  });
};

export default playYoutubeVideo;
